import axios from '../../app/common/libs/http';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { setUserSubscription } from '../auth/authSlice';


export const fetchProducts = createAsyncThunk(
  'payment/fetchProducts',
  async (id, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_APIURL}/Payment/products`
      );
      return response.data;
    } catch (err) {
      // Use `err.response.data` as `action.payload` for a `rejected` action,
      // by explicitly returning it using the `rejectWithValue()` utility

      if (err.response.data.errors) {
        if (err.response.data.errors.Payment)
          return rejectWithValue({ Errors: err.response.data.errors.Payment });
      }
      return rejectWithValue(err.response.data);
    }
  }
);

export const fetchCheckOutPlan = createAsyncThunk(
  'payment/checkoutplan',
  async (data, { rejectWithValue, dispatch }) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_APIURL}/Payment/checkout`,
        data
      );
      if (response.data) {
        dispatch(setUserSubscription(response.data));
      }

      return response.data;
    } catch (err) {
      // Use `err.response.data` as `action.payload` for a `rejected` action,
      // by explicitly returning it using the `rejectWithValue()` utility
      if (err.response.data.errors) {
        return rejectWithValue({ Errors: err.response.data });
      }
      return rejectWithValue(err.response.data);
    }
  }
);

export const fetchCancelSubscription = createAsyncThunk(
  'payment/cancelsubscription',
  async (data, { rejectWithValue, dispatch }) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_APIURL}/Payment/cancelSubscription/${data.accountId}/${data.subscriptionId}`
      );
      dispatch(setUserSubscription(null));
      return response.data;
    } catch (err) {
      // Use `err.response.data` as `action.payload` for a `rejected` action,
      // by explicitly returning it using the `rejectWithValue()` utility

      if (err.response.data.errors) {
        if (err.response.data.errors.Payment)
          return rejectWithValue({ Errors: err.response.data.errors.Payment });
      }
      return rejectWithValue(err.response.data);
    }
  }
);

export const fetchUpdatePlan = createAsyncThunk(
  'payment/updateplan',
  async (data, { rejectWithValue, dispatch }) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_APIURL}/Payment/updatePlan/${data.accountId}/${data.productId}/${data.subscriptionId}`
      );
      console.log('updateplan api data => ', response.data);

      dispatch(setUserSubscription(response.data));

      return response.data;
    } catch (err) {
      // Use `err.response.data` as `action.payload` for a `rejected` action,
      // by explicitly returning it using the `rejectWithValue()` utility

      if (err.response.data.errors) {
        if (err.response.data.errors.Payment)
          return rejectWithValue({ Errors: err.response.data.errors.Payment });
      }
      return rejectWithValue(err.response.data);
    }
  }
);

export const getProductById = createAsyncThunk(
  'payment/getProductById',
  async (productName, { rejectWithValue, dispatch }) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_APIURL}/Payment/getProduct/${productName}`
      );
      return response.data;
    } catch (err) {
     if (err.response.data.errors) {
        if (err.response.data.errors.Payment)
          return rejectWithValue({ Errors: err.response.data.errors.Payment });
      }
      return rejectWithValue(err.response.data);
    }
  }
);

export const checkoutSession = createAsyncThunk(
  'payment/createSession',
  async (session, { rejectWithValue, dispatch }) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_APIURL}/Payment/createSession`, session
      );
      return response.data;
    } catch (err) {
     if (err.response.data.errors) {
        if (err.response.data.errors.Payment)
          return rejectWithValue({ Errors: err.response.data.errors.Payment });
      }
      return rejectWithValue(err.response.data);
    }
  }
);